import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AppText, Box, Button, ButtonRow, Header, Modal, styled } from '@streem/ui-react';
import { useCallback, useState } from 'react';
import { CameraSubject } from 'streem-sdk-protobuf';
import { useRoomSession } from '../../../../context/room_session';
import { useObservable } from '../../../..';
import { logger } from '../../../../util/logger';
export function CheckClientSupport() {
    const roomSession = useRoomSession();
    const clientCapabilities = useObservable(roomSession.room.remoteParticipantCapabilities);
    const [modalOpen, setModalOpen] = useState(true);
    const closeModal = useCallback(() => setModalOpen(false), []);
    // If 2-way video is disabled, we don't need to do anything else.
    if (roomSession.callSettings.faceToFaceModeEnabled !== true) {
        return null;
    }
    // Message indicating that the customer can receive a face camera, but cannot send a face camera.
    if (clientCapabilities[0]?.canReceiveVideo === true &&
        !(clientCapabilities[0]?.canSendCameraSubjects ?? []).includes(CameraSubject.CAMERA_SUBJECT_PERSON)) {
        return (_jsx(Modal, { isOpen: modalOpen, onClose: closeModal, variant: "danger", cardProps: { decoratorPosition: undefined }, children: _jsxs(ModalContent, { children: [_jsx(Box, { style: { marginBottom: '24px' }, children: _jsx(Header, { size: "xlarge", children: "Customer device has no front camera" }) }), _jsx(MessageText, { size: "large", as: "p", children: "Your customer will see your face, but you will not see theirs." }), _jsx(Footer, { children: _jsx(Button, { variant: "transparent", fontColor: "azure", onClick: closeModal, fontSize: "large", children: "Continue" }) })] }) }));
    }
    // Message indicating that the customer cannot send or receive face camera video tracks.
    const canReceiveVideo = clientCapabilities[0]?.canReceiveVideo ?? true;
    if (canReceiveVideo !== true) {
        logger.info(`Remote participant needs to update 2-way video, clientCapabilities: ${clientCapabilities}`);
        return (_jsx(Modal, { isOpen: modalOpen, onClose: closeModal, variant: "danger", cardProps: { decoratorPosition: undefined }, inCall: true, children: _jsxs(ModalContent, { children: [_jsx(Box, { style: { marginBottom: '24px' }, children: _jsx(Header, { size: "xlarge", children: "Customer needs to update their app for 2-way video" }) }), _jsx(MessageText, { size: "large", as: "p", children: "Your customer needs to update their app to chat face-to-face. This call will continue as a one-way video call." }), _jsx(Footer, { children: _jsx(Button, { variant: "transparent", fontColor: "azure", onClick: closeModal, fontSize: "large", style: { border: 'transparent' }, children: "Continue" }) })] }) }));
    }
    // All good for bi-directional 2-way video.
    return null;
}
const ModalContent = styled.div `
    width: 500px;
    height: 200px;
`;
const Footer = styled(ButtonRow) `
    position: absolute;
    right: -20px;
    bottom: 20px;
`;
const MessageText = styled(AppText) `
    line-height: 25px;
    margin-top: 16px;
`;
//# sourceMappingURL=check_client_support.js.map